import { render, staticRenderFns } from "./FundBasicUs.vue?vue&type=template&id=17d4e5a1&scoped=true"
import script from "./FundBasicUs.vue?vue&type=script&lang=js"
export * from "./FundBasicUs.vue?vue&type=script&lang=js"
import style0 from "./FundBasicUs.vue?vue&type=style&index=0&id=17d4e5a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4e5a1",
  null
  
)

export default component.exports